import { defineComponent as _defineComponent } from 'vue'
import PersonalDetailsEditor from '@/app/components/settings/individual/PersonalDetailsEditor.vue';
import ProfilePhotoEditor from '@/app/components/settings/individual/ProfilePhotoEditor.vue';
import FileUploadCounter from 'ah-common-lib/src/common/components/upload/FileUploadCounter.vue';
import DocumentsUploader from '@/app/components/settings/client/DocumentsUploader.vue';
import { ClientFileCategories, UploadedFile } from 'ah-api-gateways';
import { useAuthStore } from '@/app/store/authStore';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalSettingsView',
  setup(__props) {

const files = ref<UploadedFile[]>([]);

const authStore = useAuthStore();

const individualSettingsStore = useIndividualSettingsStore();

const companyFileCategories = computed(() => [
  ClientFileCategories.PROOF_OF_ADDRESS,
  ClientFileCategories.PROOF_OF_FUNDS,
  ClientFileCategories.PHOTO_ID,
]);

const numberOfFiles = computed(
  () => files.value.filter((file) => companyFileCategories.value.includes(file.category as ClientFileCategories)).length
);

const isClientUser = authStore.isClientUser;

const isIndividualClientUser = computed(
  () => individualSettingsStore.client && !authStore.isAgent && !authStore.isCompanyClient
);

const client = computed(() => individualSettingsStore.client);

return { __sfc: true,files, authStore, individualSettingsStore, companyFileCategories, numberOfFiles, isClientUser, isIndividualClientUser, client, PersonalDetailsEditor, ProfilePhotoEditor, FileUploadCounter, DocumentsUploader }
}

})